/**
 * Module dependencies.
 */

import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';
import { DatePicker, DatePickerProps } from './date-picker';
import React, { ForwardedRef, forwardRef } from 'react';

/**
 * `Props` type.
 */

type Props<T extends FieldValues> = UseControllerProps<T> &
  DatePickerProps & {
    normalizeValue?: (newValue: string, value: string) => string;
  };

/**
 * `DatePickerComponent` component.
 */

export function DatePickerComponent<T extends FieldValues>(
  props: Props<T>,
  forwardedRef: ForwardedRef<any>
): JSX.Element {
  const { control, defaultValue, name, normalizeValue, rules, shouldUnregister, ...inputProps } = props;

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field: { name, onBlur, onChange, value }, fieldState: { error, invalid, isDirty, isTouched } }) => {
        return (
          <DatePicker
            invalid={invalid}
            isDirty={isDirty}
            isTouched={isTouched}
            name={name}
            onBlur={onBlur as any}
            value={value}
            {...inputProps}
            error={error}
            onChange={newValue => {
              const finalValue = normalizeValue ? normalizeValue(String(newValue), value) : newValue;

              onChange(finalValue);
            }}
            ref={forwardedRef}
          />
        );
      }}
      rules={rules}
      shouldUnregister={shouldUnregister}
    />
  );
}

/**
 * Export `DatePickerField`.
 */

export const DatePickerField = forwardRef<Props<any>, any>(DatePickerComponent as any);
